export const getValidationEstacionModal = () => {
    return {
        estacionesForm: {
            nombre_estacion: [ {required: true, message: 'Nombre estacion es requerido' } ],
            descripcion: [ {required: true, message: 'Descripción es requerido' } ],
            coord_e: [ {required: true, message: 'Coord E es requerido' } ],
            coord_n: [ {required: true, message: 'Coord N es requerido'} ],
            utm: [ {required: true, message: 'UTM es requerido' } ],
            altitud: [ {required: true, message: 'Altitud es requerido'} ]
        },
        grupoDestiForm: {
            nombre_grupo_destinatario: [ {required: true, message: 'Nombre Grupo es requerido' } ],
        },
        grupoFacturaForm: {
            nombre_grupo_facturacion: [ {required: true, message: 'Nombre Grupo es requerido' } ],
        },
        titularFacturaForm: {
            nombre_titular_factura: [ {required: true, message: 'Nombre Titular es requerido' } ]
        }
    }
}
